import { Icon } from '@iconify/react';
import { Handle, Position } from '@xyflow/react';

export const InputDocumentNode = ({ id, data }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)", width: "100px", alignItems: "center", justifyContent: "center" }}>
      <div style={{ backgroundColor: "var(--content-item-bg)", padding: "0 4px", fontSize: "14px", fontWeight: 600, color: "var(--main-font-color)" }}>
        Document
      </div>
      <div>
        <Icon icon="mdi:file-document" style={{ fontSize: "72px", color: "var(--main-font-color)" }} />

      </div>
      <Handle type="source" position={Position.Right} style={{ height: "12px", width: "12px" }} id="document-text" />
    </div>
  );
};

export default InputDocumentNode;
